import { render, staticRenderFns } from "./DirectDebitSettings.vue?vue&type=template&id=5cedeea0&"
import script from "./DirectDebitSettings.vue?vue&type=script&lang=js&"
export * from "./DirectDebitSettings.vue?vue&type=script&lang=js&"
import style0 from "./DirectDebitSettings.vue?vue&type=style&index=0&id=5cedeea0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cedeea0')) {
      api.createRecord('5cedeea0', component.options)
    } else {
      api.reload('5cedeea0', component.options)
    }
    module.hot.accept("./DirectDebitSettings.vue?vue&type=template&id=5cedeea0&", function () {
      api.rerender('5cedeea0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/SettingsList/DirectDebitSettings.vue"
export default component.exports